import React from 'react'
import loader from 'src/hoc/loader'
import PageNotFound from 'src/components/Errors/NotFound'

import { fetchCyclesBySpacePlan } from '../store'
import Cycles from './Cycles'

const getData = async ({ id }, dispatch) => {
  await dispatch(fetchCyclesBySpacePlan(id)).unwrap()
}

const options = {
  Custom404: (
    <PageNotFound
      title="Cycle Not Found"
      message="The cycle you are looking for cannot be found."
    />
  ),
  extractProps: ({ params, authData, children }) => ({ ...params, ...authData, children }),
  shouldRefresh: ({ id: previousId }, { id }) => previousId !== id,
}

export default loader(getData, options)(Cycles)
